/*
* Created on Jan 14, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import { useEffect, useState } from 'react';
import axios from 'axios';
import {useOrganizationApi} from "./OrganizationAPIHook";


export default function useHookSearch(path, query, offset, refresh, isAppend) {
    const {OrganizationAPI} = useOrganizationApi();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [result, setResult] = useState([]);
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        setResult([])
    }, [path])

    useEffect( () => {
        let cancel

        setLoading(true)
        setError(false)

        const params = {limit: 5, offset: offset}
        if (query) {
            params['name'] = query
        }
        const api_req_config = OrganizationAPI.getConfig(path, 'GET', params)
        api_req_config['cancelToken'] = new axios.CancelToken(c => cancel = c)

        axios(api_req_config).then(res => {
            if (isAppend) {
                setResult(prevBooks => {
                    return [...new Set([...prevBooks, ...res.data.result])]
                })
            }
            else {
               setResult(prevBooks => {
                    return res.data.result
               })
            }

            setHasMore(res.data.result.length > 0)
            setLoading(false)
        }).catch(e => {
            if (axios.isCancel(e)) return
            console.log(e)
            setError(true)
            setLoading(false)
        });

        return () => cancel()
    }, [path, offset, refresh, query])

    return { loading, error, result, hasMore, setResult }

}